import { render, staticRenderFns } from "./GroupHeadTable.vue?vue&type=template&id=579e2054&scoped=true&"
import script from "./GroupHeadTable.vue?vue&type=script&lang=js&"
export * from "./GroupHeadTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupHeadTable.vue?vue&type=style&index=0&id=579e2054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579e2054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VTooltip})
